import React from 'react'

const Graf = () => {
  return (
    <div style={{padding: '30%' }}>Graficaaaaa</div>
  )
}

export default Graf